import { PatientFormControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Props {
  patientForms: Array<string>;
  patientId: string;
  xTENANTID?: string;
}

/**
 * @author Rajkumar Rathod
 */
export const useSendPatientForms = () =>
  useMutationWithLoading(async (params: Props) =>
    new PatientFormControllerApi(getConfigObject()).sendForm(
      params.patientForms,
      params.patientId,
      params.xTENANTID
    )
  );
